// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HrRr_Q {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--surface-secondary, #fafafa);
  border-radius: 4px;
}

.wCUsjG {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.wCUsjG img {
  width: 16px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(2944%) hue-rotate(358deg) brightness(91%)
    contrast(91%);
}

.n7mAPr {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.j79FZr {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #1f1f1f);
  margin: 0;
  line-height: 1.8;
}

.QjUqAs {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-primary, #1f1f1f);
  margin: 0;
  line-height: 1.8;
}

.NminUi {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.SlapOG,
.gKLkEd {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.SlapOG:hover {
  background-color: var(--surface-hover, #f5f5f5);
}

.gKLkEd:hover {
  background-color: var(--surface-error, #fff5f5);
}

.SlapOG img,
.gKLkEd img {
  width: 16px;
  height: 16px;
}

.SlapOG img {
  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(2944%) hue-rotate(358deg) brightness(91%)
    contrast(91%);
}

.gKLkEd img {
  filter: brightness(0) saturate(100%) invert(8%) sepia(100%) saturate(7482%) hue-rotate(357deg) brightness(95%)
    contrast(118%);
}

/* Responsive styles */
@media (max-width: 480px) {
  .HrRr_Q {
    padding: 12px;
    gap: 12px;
  }

  .wCUsjG {
    width: 20px;
    height: 20px;
  }

  .wCUsjG img {
    width: 14px;
    height: 14px;
  }

  .j79FZr,
  .QjUqAs {
    font-size: 13px;
  }

  .SlapOG,
  .gKLkEd {
    width: 28px;
    height: 28px;
  }

  .SlapOG img,
  .gKLkEd img {
    width: 14px;
    height: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixKeyItem/PixKeyItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;iBACe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;iBACe;AACjB;;AAEA;EACE;kBACgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".keyItem {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: var(--surface-secondary, #fafafa);\n  border-radius: 4px;\n}\n\n.keyIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.keyIcon img {\n  width: 16px;\n  height: 16px;\n  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(2944%) hue-rotate(358deg) brightness(91%)\n    contrast(91%);\n}\n\n.keyContent {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.keyLabel {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary, #1f1f1f);\n  margin: 0;\n  line-height: 1.8;\n}\n\n.keyValue {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-primary, #1f1f1f);\n  margin: 0;\n  line-height: 1.8;\n}\n\n.keyActions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.copyButton,\n.deleteButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.copyButton:hover {\n  background-color: var(--surface-hover, #f5f5f5);\n}\n\n.deleteButton:hover {\n  background-color: var(--surface-error, #fff5f5);\n}\n\n.copyButton img,\n.deleteButton img {\n  width: 16px;\n  height: 16px;\n}\n\n.copyButton img {\n  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(2944%) hue-rotate(358deg) brightness(91%)\n    contrast(91%);\n}\n\n.deleteButton img {\n  filter: brightness(0) saturate(100%) invert(8%) sepia(100%) saturate(7482%) hue-rotate(357deg) brightness(95%)\n    contrast(118%);\n}\n\n/* Responsive styles */\n@media (max-width: 480px) {\n  .keyItem {\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .keyIcon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .keyIcon img {\n    width: 14px;\n    height: 14px;\n  }\n\n  .keyLabel,\n  .keyValue {\n    font-size: 13px;\n  }\n\n  .copyButton,\n  .deleteButton {\n    width: 28px;\n    height: 28px;\n  }\n\n  .copyButton img,\n  .deleteButton img {\n    width: 14px;\n    height: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyItem": `HrRr_Q`,
	"keyIcon": `wCUsjG`,
	"keyContent": `n7mAPr`,
	"keyLabel": `j79FZr`,
	"keyValue": `QjUqAs`,
	"keyActions": `NminUi`,
	"copyButton": `SlapOG`,
	"deleteButton": `gKLkEd`
};
module.exports = ___CSS_LOADER_EXPORT___;
